import React from "react";
import { Row, Col } from "react-bootstrap";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const WebHosting = () => {
  return (
    <section className="hosting-banner">
      <div className="hosting-outer">
        <div className="container-layout">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <h1 className='text-center'> WEB HOSTING</h1>
              <p className='text-center'>

                Web hosting is a service that allows individuals and organizations to make their websites accessible on the internet. In simple terms, web hosting companies provide the necessary infrastructure and resources to store and serve your website's files, making it available for users to access through their web browsers.
              </p>

            </div>


          </div>
        </div>

      </div>
      <div className="hosting-second-outer">
        <div className="container-layout">
          <div className="hosting-heading">
            <h6>BEST WEB HOSTING IN ABOHAR</h6>
            <h1>Web Hosting Services</h1>
          </div>
          <Row className="mt-4">
            <Col lg={6}>
              <div className="hosting-service-details">
                <p>
                  It is true that there is no place of slow websites on Google
                  as visitors do not like them at all. When the website is slow,
                  then its visitors go away from your website and find another
                  one to buy something or obtain information. Possibly, you have
                  worked too hard on your website, of course, you would not want
                  to ruin it at any cost. This is why it is a very good idea to
                  get your site hosted on a reliable platform that gives
                  high-speed to it.
                </p>
                <p>
                  Delivering top quality and fast web hosting services to our
                  clients is our motto. We have ultra-reliable and
                  high-performance web hosting solutions to offer, making the
                  websites reach the level of success. You can stay ahead in the
                  competitive market after getting high speed for page loading
                  and other features. No matter whether you have an existing
                  website or need to build a new website, our web hosting
                  solutions are the best ones to consider.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="hosting-feature">

                <p>
                  In any case, if there is any problem related to web servers on
                  which your website is hosted, then don’t panic at all as we
                  can get out of this problem very easily. Our professional
                  technical support is available 24x7. You can contact us via
                  chat or email or phone. So, choose any cheaper web hosting
                  package.
                </p>
                <h6>Features to explore:</h6>
                <ul className="hosting-ul">
                  <li><ArrowRightAltIcon />Cache optimization</li>
                  <li><ArrowRightAltIcon />Affordable web hosting plans</li>
                  <li><ArrowRightAltIcon />Unlimited hosting</li>
                  <li><ArrowRightAltIcon />Windows hosting</li>
                  <li><ArrowRightAltIcon />VPS Hosting</li>
                  <li><ArrowRightAltIcon />Dedicated server hosting</li>
                </ul>

              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default WebHosting;
